import { render, staticRenderFns } from "./OrderFail.vue?vue&type=template&id=edcd3286"
import script from "./OrderFail.vue?vue&type=script&lang=js"
export * from "./OrderFail.vue?vue&type=script&lang=js"
import style0 from "./OrderFail.vue?vue&type=style&index=0&id=edcd3286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports